export default __webpack_public_path__ + "static/media/toll.36ffd2f9.svg";